import { createConsumer } from '@rails/actioncable';

// Shipped since Action Cable 7.1; the installed type definitions predate it.
declare module '@rails/actioncable' {
  interface Consumer {
    addSubProtocol(subprotocol: string): void;
  }
}

const httpRegex = /^http:\/\//;
const httpsRegex = /^https:\/\//;
const BASE_SOCKET_URL = `${process.env.REACT_APP_API_SERVER_URL?.replace(httpRegex, 'ws://').replace(
  httpsRegex,
  'wss://'
)}/cable`;

// Offered as a subprotocol rather than put in the URL, which access logs record.
const BEARER_PROTOCOL = 'upstack-bearer.';

// A subprotocol must be an HTTP token, and standard base64's "/" and "=" are not token characters.
const toBase64Url = (base64: string) => base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

const createActionCableConsumer = (bearer?: string) => {
  const consumer = createConsumer(BASE_SOCKET_URL);
  if (bearer) consumer.addSubProtocol(`${BEARER_PROTOCOL}${toBase64Url(bearer)}`);
  return consumer;
};

export const createSessionConsumer = (channel: string) => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error(`Unable to start ${channel} channel, invalid credentials`);
    return;
  }

  return createActionCableConsumer(token);
};

export default createActionCableConsumer;
